import {
  GET_CAMPAIGN_LIST,
  GET_CAMPAIGN_LIST_FAILURE,
  GET_CAMPAIGN_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCampaignListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_LIST:
      return { ...state, loading: true };
    case GET_CAMPAIGN_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CAMPAIGN_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCampaignListReducer;
